import { useTracking } from '@change-corgi/core-react/tracking';

import { useLocalPageData, useLocalPagePaginatedDecisionMakersData } from '#src/app/pages/local/details/pageContext';
import type { LocalDecisionMakersItem } from '#src/app/pages/local/details/pageContext';

type Result = ModelHookResult<
	{
		displayed: boolean;
		displayName: string;
		decisionMakers: readonly LocalDecisionMakersItem[];
		hasNextPage: boolean;
		nextPageLoading: boolean;
	},
	{
		loadMore: () => void;
	}
>;

export function useDecisionMakersSection(): Result {
	const {
		data: { displayName },
	} = useLocalPageData();
	const track = useTracking();

	const {
		data: { hasNextPage, items, nextPageLoading, totalCount },
		actions: { loadMore },
	} = useLocalPagePaginatedDecisionMakersData();

	return {
		data: {
			decisionMakers: items,
			displayed: totalCount > 0,
			displayName,
			hasNextPage,
			nextPageLoading,
		},
		actions: {
			loadMore: () => {
				void track('local_page_load_more_decision_makers_click');
				loadMore();
			},
		},
	};
}
